import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-with-text-block.component.scss';
var ImageWithTextBlock = /** @class */ (function (_super) {
    tslib_1.__extends(ImageWithTextBlock, _super);
    function ImageWithTextBlock(element) {
        return _super.call(this, element) || this;
    }
    ImageWithTextBlock.prototype.init = function () {
    };
    ImageWithTextBlock.prototype.bindEvents = function () {
    };
    return ImageWithTextBlock;
}(Base));
export { ImageWithTextBlock };



//////////////////
// WEBPACK FOOTER
// ./components/image-with-text-block/image-with-text-block.component.ts
// module id = 380
// module chunks = 0